import { useEffect } from "react";
import { KeywordsCard } from "./card";
import { KeywordsNew } from "./new";
import { Routes, Route } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { KeywordsTable } from "./table";

export default function Keyword() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Mots clés");
  }, []);

  return (
    <Routes>
      <Route index element={<KeywordsTable />} />
      <Route path="/new" element={<KeywordsNew />} />
      <Route path=":id" element={<KeywordsCard />} />
    </Routes>
  );
}
